export default __webpack_public_path__ + "static/media/certificateAlt.bb5884ad.png";